import { IApplicationState } from '../../../../../../types/types';

export const isRelatedCardsPanelOpened = (
    state: IApplicationState
): boolean => {
    return state.relatedCards && !!state.relatedCards.cardId; // TODO вероятно улучшить, пока просто смотрим, что для какой-то карты открыта панель
}
